import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';

import * as fromApp from '../store/app.reducers';
import * as fromAuth from '../auth/store/auth.reducers';
import {take, switchMap} from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private store: Store<fromApp.AppState>
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.store.select('auth')
      .pipe(
        take(1),
        switchMap(
          (authState: fromAuth.State) => {
            const requestUrl = req.url;
            if (requestUrl.indexOf('token') === -1
              && requestUrl.indexOf('users/facebook') === -1
              && requestUrl.indexOf('users/google') === -1
            ) {
              if (authState.token !== undefined) {
                const headers = new HttpHeaders().set('Authorization', 'Bearer ' + authState.token);
                const copyReq = req.clone(
                  {
                    headers: headers
                  }
                );
                return next.handle(copyReq);
              }
            }
            return next.handle(req);
          }
        )
      );
  }
}
